import * as React from "react";
import Navbar from "../../Components/Navbar";
import { sendGetRequest, useGetRequest, sendPostRequest } from "../../Client";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Button, Table, Modal } from "flowbite-react";
import { useState } from "react";
import CountryDropdown from "../../Components/CountryDropdown";
import { useNavigate } from "react-router-dom";
import { Notyf } from "notyf";
import "notyf/notyf.min.css"; // for React, Vue and Svelte
import Header from "../../Components/Header";
import Swal from "sweetalert2";
import dateFormat, { masks } from "dateformat";

export default function AdvisorStatementsList() {
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const domain = "https://money-trove.org";

  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
  });

  const addedNotyf = () => {
    notyf.success("User added");
  };

  // loading statements
  const { data: statements, isLoading } = useQuery({
    queryFn: () => sendGetRequest("advisor/statements/list", {}),
    queryKey: ["statements"],
  });

  const getAdvisorPDF = async () => {
    alert("Generating PDF...");
    //window.open(domain + `/advisor/statement/pdf`);
  };

  const getAdvisorCSV = async () => {
    alert("Generating CSV...");
    //window.open(domain + `/advisor/statement/csv`);
  };

  if (!isLoading) {
    return (
      <>
        <Header />

        <section className="bg-gray-100 dark:bg-gray-900 py-3 sm:py-5">
          <div className="px-4 mx-auto max-w-screen-2xl lg:px-12 mb-80">
            <div className="relative overflow-hidden bg-white shadow-md dark:bg-gray-800 sm:rounded-lg">
              <div className="border-b border-gray-200 pb-5 sm:flex sm:items-center sm:justify-between w-[94%] ml-[3%] mt-[3%] pb-6">
                <h3 className="text-base font-semibold text-gray-900">
                  Advisor Statements
                </h3>
              </div>

              <div className="overflow-x-auto p-6">
                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-4 py-3 w-1/4">
                        Date
                      </th>
                      <th scope="col" className="px-4 py-3 w-1/4">
                        Name
                      </th>
                      <th scope="col" className="px-4 py-3 w-1/4 ">
                        Total
                      </th>

                      <th scope="col" className="px-4 py-3 w-1/4"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {statements?.statements.map((statement) => (
                      <tr className="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
                        <td className="px-4 py-2">
                          <div className="flex items-center text-sm font-medium text-gray-500">
                            {dateFormat(statement.createdAt, "mmmm dS, yyyy")}
                          </div>
                        </td>

                        <td className="px-4 py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">
                          {statement.firstName} {statement.surname}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">
                          £{statement.total}
                        </td>

                        <td>
                          <button
                            onClick={getAdvisorPDF}
                            className="w-20 ml-8 h-10 rounded-md bg-slate-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600"
                          >
                            PDF
                          </button>
                          <button
                            onClick={getAdvisorCSV}
                            className="w-20 ml-8 h-10 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                          >
                            CSV
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
